// extracted by mini-css-extract-plugin
export var dropdown = "_ti-0";
export var imageWrapper = "_ti-3";
export var itemNameContainer = "_ti-1";
export var productImage = "_ti-2";
export var spinnerWrapper = "_ti-4";